import { useEffect, useState } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar.jsx';
import Footer from './components/Footer.jsx';
import CookieConsent from './components/CookieConsent.jsx';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Foscan from './pages/Foscan.jsx';
import PDT from './pages/PDT.jsx';
import HeadNeckCancer from './pages/HeadNeckCancer.jsx';
import Contact from './pages/Contact.jsx';
import AdverseEventReport from './pages/AdverseEventReport.jsx';
import Sitemap from './pages/Sitemap.jsx';
import Imprint from './pages/Imprint.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';

const SITE_NAME = 'biolitec Pharma';

/* Page titles per route (WCAG 2.4.2). Keys must match the Route paths below. */
const TITLES = {
  '/': 'Photodynamic therapy solutions',
  '/about': 'About us',
  '/foscan': 'Foscan\u00ae',
  '/pdt': 'Photodynamic therapy',
  '/head-neck-cancer': 'Head and neck cancer',
  '/adverse-event-report': 'Report an adverse event',
  '/contact': 'Contact',
  '/sitemap': 'Sitemap',
  '/imprint': 'Imprint',
  '/privacy-policy': 'Privacy policy',
};

/* On every route change: set the document title, announce the change to
   assistive technology, reset scroll, and move focus to the start of the
   new page so keyboard and screen-reader users are not left mid-document. */
function RouteChangeHandler() {
  const { pathname } = useLocation();
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    const label = TITLES[pathname];

    document.title = label ? `${label} \u2014 ${SITE_NAME}` : SITE_NAME;
    setAnnouncement(`${label || 'Page'} loaded`);

    window.scrollTo(0, 0);
    const main = document.getElementById('main-content');
    if (main) main.focus({ preventScroll: true });
  }, [pathname]);

  return (
    <div aria-live="polite" aria-atomic="true" className="visually-hidden">
      {announcement}
    </div>
  );
}

export default function App() {
  return (
    <HashRouter>
      <RouteChangeHandler />
      <a className="skip-link" href="#main-content">Skip to main content</a>
      {/* NOTE: the previous global <MoleculeField /> layer has been removed.
          Molecular graphics are now scoped per section via
          <MolecularBackground /> inside Hero and PlatformBanner. */}
      <Navbar />
      <main id="main-content" tabIndex={-1} className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/foscan" element={<Foscan />} />
          <Route path="/pdt" element={<PDT />} />
          <Route path="/head-neck-cancer" element={<HeadNeckCancer />} />
          <Route path="/adverse-event-report" element={<AdverseEventReport />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
    </HashRouter>
  );
}